@if (item().orderedExtrasSignal()?.length) {
    <div class="extras">
        @if (showTotal() && item().initiatedExtrasTotalSignal()) {
            <div class="extras-total">
                {{ 'woa.label.extras.extrasTotal' | translate: {total: item().initiatedExtrasTotalSignal() | woaCurrency} }}
            </div>
        }
        @for (orderedExtra of item().orderedExtrasSignal(); track orderedExtra; let i = $index) {
            @if (orderedExtra.isVisibleSignal()) {
                <div class="extras-extra" id="extra-{{i}}"
                     [ngClass]="{
                         'single-select': orderedExtra.isGroupSignal(),
                         'nested': orderedExtra.isNestedSignal()
                     }">
                    @if (orderedExtra.quantitySignal() > 1) {
                        <div class="extras-extra-qty">{{ orderedExtra.quantitySignal() }}</div>
                    }
                    <div class="extras-extra-item">{{ orderedExtra.nameSignal() }}</div>
                </div>
            }
        }
    </div>
}
